import React, { AllHTMLAttributes, FC, PropsWithChildren } from 'react';

import { cn } from '../../../../utils';

import './GridRowHeader.scoped.scss';

interface Props extends AllHTMLAttributes<HTMLDivElement> {}

const GridRowHeader: FC<PropsWithChildren<Props>> = ({ children, ...props }) => {
  return (
    <div {...props} className={cn('grid-row-header', props.className)}>
      {children}
    </div>
  );
};

export default GridRowHeader;
